// @ts-nocheck
import PropTypes from "prop-types";
import {ErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {BaseButton, BaseModal} from "@/components";
import {useLogo} from "../../../util/logoUtils";

const containerCls = "flex m-4 flex-col justify-center items-center h-[50vh] text-[var(--color-warning)]";
const logoCls = "w-[var(--size-50)] mb-4 max-md:w-[150px]";
const titleCls = "text-[clamp(18px,2vw,25px)] font-normal mb-4 text-center";

const ErrorBoundaryAppFallback = ({resetErrorBoundary}) => {
  const {t} = useTranslation();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetErrorBoundary();
  };

  return (
    <BaseModal
      open={true}
      onClose={() => {}}
      size="lg"
      closeOnOverlayClick={false}
      closeOnEscape={false}
    >
      <div className={containerCls}>
        <img
          src={logoImg}
          alt="Logo"
          className={logoCls}
        />
        <p className={titleCls}>{t("errorBoundaryAPPMessage1")}</p>
        <p style={{fontSize: "var(--font-h3)", textAlign: "center"}}>{t("errorBoundaryAPPMessage2")}</p>

        <BaseButton
          variant="primary"
          onClick={handleErrorState}
          style={{marginTop: 30}}
        >
          {t("errorBoundaryBtnReload")}
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export const ErrorBoundaryApp = ({children}) => {
  return <ErrorBoundary FallbackComponent={ErrorBoundaryAppFallback}>{children}</ErrorBoundary>;
};

ErrorBoundaryApp.propTypes = {
  children: PropTypes.node,
  error: PropTypes.any,
};
